export default {
  init() {
    // console.log('xxx');
    var siteURL = $('#site-url').data('url');

    var ticketsDiv = $(".ticket-section");

    var parentID = ticketsDiv.data('parentid');
    console.log("parent id", parentID);

    const loaderElement = $(".loader-tix");
    const tixDiv = $(".ticket-list");

    if (parentID != "no") {
      if (ticketsDiv.length) {
        $.ajax({
          url: siteURL + "/wp-json/events/v2/tickets/",
          // url: "https://staging.wereldhavendagen.nl/wp-json/events/v2/tickets/",
          type: 'GET',
          success: function (data) {
            // console.log("AT tickets", data);

            var dataArray = data.result.soap_response;

            //for TEST
            const jsonData = {
              "ProgramList": {
                "Programm": {
                  "494": {
                    "ProgramId": "93439",
                    "EventId": "90521",
                    "Title": "Bezoek Alco Energy Rotterdam: innovatieve biochemie",
                    "AvailabilityStatus": "false"
                  },
                  "495": {
                    "ProgramId": "93398",
                    "EventId": "90658",
                    "Title": "Fietsvaren op de Schiller Waterbike op de Rijnhaven",
                    "AvailabilityStatus": "true"
                  },
                  "496": {
                    "ProgramId": "93408",
                    "EventId": "90818",
                    "Title": "Rondvaart op de binnenwateren van Rotterdam met schipper en audiogids",
                    "AvailabilityStatus": "true"
                  },
                  "497": {
                    "ProgramId": "93440",
                    "EventId": "90521",
                    "Title": "Bezoek Alco Energy Rotterdam: innovatieve biochemie",
                    "AvailabilityStatus": "false"
                  },
                  "498": {
                    "ProgramId": "93394",
                    "EventId": "90658",
                    "Genre": "Boot",
                    "ImageId": "0",
                    "Title": "Fietsvaren op de Schiller Waterbike op de Rijnhaven",
                    "AvailabilityStatus": "true"
                  },
                  "500": {
                    "ProgramId": "90018",
                    "EventId": "90658",
                    "Genre": "Boot",
                    "ImageId": "0",
                    "Title": "piri peng",
                    "AvailabilityStatus": "true"
                  }
                }
              }
            };

            var programs = dataArray.ProgramList.Program;

            var programDetails = Object.keys(programs).map(function (key) {
              var program = programs[key];
              if (program.EventId == parentID) {

                var startDate = new Date(program.ProgramStart);
                var endDate = new Date(program.ProgramEnd);

                // Formatting date
                var dayNames = ["Zo.", "Ma.", "Di.", "Wo.", "Do.", "Vr.", "Za."];
                var monthNames = ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];

                var formattedDate = dayNames[startDate.getDay()] + ' ' + startDate.getDate() + ' ' + monthNames[startDate.getMonth()] + ' ' + startDate.getFullYear();

                // Formatting time
                // Extract the time in the original time zone (Netherlands time)
                const timeFormatter = new Intl.DateTimeFormat('en-US', {
                  timeZone: 'Europe/Amsterdam', // Netherlands time zone
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false // 24-hour format
                });

                var startTime = timeFormatter.format(startDate);
                var endTime = timeFormatter.format(endDate);

                var formattedTime = startTime + ' - ' + endTime;

                return {
                  ProgramId: parseInt(program.ProgramId, 10),
                  AvailabilityStatus: program.AvailabilityStatus,
                  date: formattedDate,
                  time: formattedTime
                };
              }
            }).filter(Boolean); // Remove undefined values

            console.log("programDetails", programDetails);

            var soldoutImage = $('.ticket-list .soldout-img').data('soldout');
            var availableImage = $('.ticket-list .available-img').data('available');

            var tixSaleStart = $('.tix-sale-start').data('tix-sale-start');
            var tixStartSell = $('.tix-start-sell').data('tix-start-sell');


            function updateTicketList(programDetails) {
              var ticketsList = document.getElementById('ticket-list');
              ticketsList.innerHTML = ''; // Clear existing tickets

              programDetails.forEach(function (program) {
                var ticketTemplate = `
                  <div class="ticket" id="subject-id" data-subjectid="${program.ProgramId}">
                    <div class="ticket-details pt-2 px-4" id="" data-stagger="">
                      <div class="ticket-date flex justify-between items-center">
                        <div class="capitalize date">
                          ${program.date}
                        </div>
                        <div class="ticket-image">
                          <div class="soldout hidden" data-soldout='@asset("images/tickets-soldout.png")'></div>
                          <div class="available hidden" data-available='@asset("images/icon-chevron-white-right.svg")'></div>
                        </div>
                      </div>
                      <div class="ticket-time border-b border-white border-opacity-25 pb-2">
                        ${program.time}
                      </div>
                    </div>
                    <div class="ticket-purchase">
                      <!-- Additional ticket purchase info here -->
                    </div>
                  `;

                if (tixSaleStart == 1) {
                  var ticketTemplateLink = `
                    <div class="ticket-actions">
                      <div class="bg-blue px-6 my-2">
                        <a id="tix-link-${program.ProgramId}" href="https://tickets.wereldhavendagen.nl/Show/Details/${program.ProgramId}" class="bg-yellow block w-full mb-2 h-12 xl:h-14 font-semibold flex items-center justify-center">Bestel tickets</a>
                        <a href="${siteURL}/programma-2024" class="border block border-white block w-full h-12 xl:h-14 font-semibold flex items-center justify-center">Doorgaan met winkelen</a>
                      </div>
                    </div>
                  </div>
              `;
                }
                else {
                  var ticketTemplateLink = `
                    <div class="ticket-purchase">
                      <div class="text-white px-8 my-2 opacity-75 italic">
                        Ticket verkoop start op ${tixStartSell}
                      </div>
                    </div>
                  </div>
                `;
                }


                // Append the ticket to the list
                ticketsList.insertAdjacentHTML('beforeend', ticketTemplate + ticketTemplateLink);
              });
            }


            updateTicketList(programDetails);


            $('.ticket').each(function () {
              var subjectID = $(this).data('subjectid');
              var subjectIDInt = parseInt(subjectID, 10);

              // Check if the subjectID exists in programDetails
              var found = programDetails.find(function (programDetail) {
                return programDetail.ProgramId === subjectIDInt;
              });

              if (found) {
                var ticketElement = $(`.ticket[data-subjectid="${subjectID}"]`);
                var status = found.AvailabilityStatus;

                if (ticketElement.length) {
                  var ticketDetails = ticketElement.find('.ticket-details');
                  var ticketDate = ticketElement.find('.ticket-date .capitalize');
                  var ticketTime = ticketElement.find('.ticket-time');
                  var ticketImage = ticketElement.find('.ticket-image');


                  if (status === "false") {
                    ticketDetails.addClass('sold-out');
                    ticketDate.addClass('opacity-25');
                    ticketTime.addClass('opacity-25');

                    const imagey = $(`<img class="ticketverkoop w-32" src="${soldoutImage}" alt="" style="">`);
                    ticketImage.append(imagey);

                  } else {
                    ticketDetails.addClass('hover:opacity-75 cursor-pointer');
                    ticketDate.addClass('opacity-100');
                    ticketTime.addClass('opacity-100');

                    const imagey = $(`<img class="ticket-chevron" src="${availableImage}" alt="" style="">`);
                    ticketImage.append(imagey);
                  }
                }

              }
            });

            $('.ticket-details').on('click', function () {
              const staggerId = $(this).data('stagger');
              const disabledTicket = $(this).hasClass('sold-out');
              // console.log($(this).hasClass('opacity-25'));

              if (disabledTicket) {
                return false;
              } else {
                const selectedTicket = $(this).parent('.ticket');
                const selectedChevron = $(this).find('.ticket-chevron');
                const selectedIframe = $(this).siblings('.ticket-purchase').find('.iframe');

                const xlAbove = $(window).outerWidth() >= 1280;
                const lgScreen =
                  $(window).outerWidth() >= 1024 && $(window).outerWidth() < 1280;
                const mdScreen =
                  $(window).outerWidth() >= 768 && $(window).outerWidth() < 1024;
                const mdBelow = $(window).outerWidth() < 768;

                // only 1 chevron at a time
                $('.ticket-chevron')
                  .not(selectedChevron)
                  .removeClass('selected');

                // only 1 ticket purchase at a time
                if (xlAbove) {
                  $('.ticket')
                    .not(selectedTicket)
                    .css('max-height', '89px');
                } else if (lgScreen) {
                  $('.ticket')
                    .not(selectedTicket)
                    .css('max-height', '79px');
                } else if (mdScreen) {
                  $('.ticket')
                    .not(selectedTicket)
                    .css('max-height', '71px');
                } else if (mdBelow) {
                  $('.ticket')
                    .not(selectedTicket)
                    .css('max-height', '69px');
                }

                if ($(selectedTicket).height() <= 89) {
                  console.log('hello');

                  // rotate chevron
                  $(selectedChevron).addClass('selected');
                  // reveal ticket purchase
                  $(selectedTicket).animate({ 'max-height': '1000px' }, 300);
                  console.log(selectedIframe);
                  $(selectedIframe).html('<iframe data-stager-ticketshop="' + staggerId + '" height="100px" width="100%" frameborder="0" src="https://wereldhavendagen.stager.nl/web/tickets/' + staggerId + '?minimal=true" style="border: 0px; background: transparent; max-width: 100%;"></iframe>');

                } else {
                  // rotate back to default
                  $(selectedChevron).removeClass('selected');
                  // hide ticket purchase
                  if (xlAbove) {
                    $(selectedTicket).animate({ 'max-height': '89px' }, 300);
                  } else if (lgScreen) {
                    $(selectedTicket).animate({ 'max-height': '79px' }, 300);
                  } else if (mdScreen) {
                    $(selectedTicket).animate({ 'max-height': '71px' }, 300);
                  } else if (mdBelow) {
                    $(selectedTicket).animate({ 'max-height': '69px' }, 300);
                  }

                }
              }
            });

            loaderElement.removeClass('active');
            tixDiv.removeClass('hidden');

          },
          error: function (error) {
            console.log(error);
          },
        });

      }
    }
    else {
      loaderElement.removeClass('active');
      tixDiv.removeClass('hidden');
    }




    // JavaScript to be fired on the about us page
    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {
      // Find marker elements within map.
      var $markers = $el.find('.marker');

      // Create gerenic map.
      var mapArgs = {
        zoom: $el.data('zoom') || 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map($el[0], mapArgs);

      // Add markers.
      map.markers = [];
      $markers.each(function () {
        initMarker($(this), map);
      });

      // Center map based on markers.
      centerMap(map);

      // Return map instance.
      return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map) {
      // Get position from marker.
      var lat = $marker.data('lat');
      var lng = $marker.data('lng');
      var latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };

      // Create marker instance.
      var marker = new google.maps.Marker({
        position: latLng,
        map: map
      });

      // Append to reference for later use.
      map.markers.push(marker);

      // If marker contains HTML, add it to an infoWindow.
      if ($marker.html()) {
        // Create info window.
        var infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function () {
          infowindow.open(map, marker);
        });
      }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap(map) {
      // Create map boundaries from all map markers.
      var bounds = new google.maps.LatLngBounds();
      map.markers.forEach(function (marker) {
        bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng()
        });
      });

      // Case: Single marker.
      if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());

        // Case: Multiple markers.
      } else {
        map.fitBounds(bounds);
      }
    }

    // Render maps on page load.
    $(document).ready(function () {
      // $('.acf-map').each(function() {
      //   var map = initMap($(this));
      // });



      const eventFavourites = JSON.parse(localStorage.getItem('eventFavourites'));
      const postid = $('.favstar').data('postid');

      if (eventFavourites !== null && eventFavourites !== undefined) {
        const findpostid = eventFavourites.find(id => postid === id);
        if (findpostid !== undefined) {
          $('.favstar').addClass('favstar-active');
        }
      }

      $('.favstar').click(function () {
        // if $(this).hasClass('fav')
        const eventFavourites = JSON.parse(localStorage.getItem('eventFavourites'));
        const postid = $('.favstar').data('postid');

        if (eventFavourites !== null && eventFavourites !== undefined) {
          const findpostid = eventFavourites.find(id => postid === id);
          if (findpostid === undefined) {
            $('.favstar').addClass('favstar-active');
            eventFavourites.push(postid);
          } else {
            $('.favstar').removeClass('favstar-active');
            const index = eventFavourites.indexOf(findpostid);
            if (index > -1) {
              eventFavourites.splice(index, 1);
            }
          }

          localStorage.setItem('eventFavourites', JSON.stringify(eventFavourites));
        } else {
          localStorage.setItem('eventFavourites', JSON.stringify([postid]));
        }

      })

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleEvent.js